import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Colors from 'assets/Style/Colors';
import { useAuth } from 'context/UseContext';
import { Box } from '@mui/material';
import { useAuthString } from 'auth/useAuthStorage';

const useStyle = makeStyles({
  step: {
    flex: 1,
    display: 'flex',
    gap: '20px',
    alignItem: 'center',
    justifyContent: 'space-between',
    '& .MuiStepLabel-label': {
      color: `${Colors.charcoalGrey} !important`,
      fontSize: { md: '16px' },
    },
  },
});

function WalletDashboard() {
  const [renderState, setRenderState] = useState();
  const { user } = useAuth();

  var METABASE_SITE_URL = 'https://analytics.galaxyshipping.com';
  const dashboardPermission = process.env.REACT_APP_METABASE_IS_ENABLED

  const walletToken = useAuthString('walletToken');
  const vccToken = useAuthString('vccToken');

  let iframeUrl =
    METABASE_SITE_URL +
    '/embed/dashboard/' +
    walletToken +
    '#bordered=false&titled=true';

  useEffect(() => {
    if (vccToken) {
      setRenderState(vccToken);
    }
  }, [vccToken]);

  return (
    <Fragment>
      {
        dashboardPermission === "true" ? (
          <>
            {user?.user_type != 'C' && renderState && (
              <Box sx={{ height: '100vh' }}>
                <iframe
                  title='buyerIdIframe'
                  src={iframeUrl}
                  frameBorder={0}
                  width={'100%'}
                  height={'100%'}
                  allowTransparency
                />
              </Box>
            )}
          </>
        ) : (
          <>
          </>
        )
      }

    </Fragment>
  );
}

export default WalletDashboard;
